const dev = {
  BACKEND_URL: "http://127.0.0.1:8080",
  GOOGLE_CLIENT_ID:
    "630755267271-6d5qg951desqou8alf1s2hpu3ef322ce.apps.googleusercontent.com",
  REDIRECT_URI: "http://localhost:3000",

  // Zoom configuration:
  ZOOM_CLIENT_ID: "unTBK_xmQ88eTZVDbn2Xg",
  ZOOM_REDIRECT_URI: "http://localhost:3000/sources/add",
};

const staging = {
  BACKEND_URL:
    "https://starmesh-server-staging-630755267271.us-central1.run.app",
  GOOGLE_CLIENT_ID:
    "630755267271-6d5qg951desqou8alf1s2hpu3ef322ce.apps.googleusercontent.com",
  REDIRECT_URI: "https://app.taskmantis.com",
};

const prod = {
  BACKEND_URL: "https://starmesh-server-630755267271.us-central1.run.app",
  GOOGLE_CLIENT_ID:
    "630755267271-6d5qg951desqou8alf1s2hpu3ef322ce.apps.googleusercontent.com",
  REDIRECT_URI: "https://app.taskmantis.com",
};

const transformDefault = {
  name: "",
  description: "",
  connectors: [],
  fileType: ".vtt",
  transformType: "",
  frequency: "",
};

const topicModelingDefault = {
  keywords: "",
  maxTopics: 10,
};

// Determine which config to use based on environment
let config;

// Use REACT_APP_ENV for environment detection since CRA overrides NODE_ENV to production during builds.
const environment = (() => {
  const explicit = String(process.env.REACT_APP_ENV || "").trim();
  if (explicit) return explicit;
  const nodeEnv = String(process.env.NODE_ENV || "").trim();
  if (nodeEnv === "development" || nodeEnv === "test") return nodeEnv;
  return "production";
})();
const backendUrlOverride = String(process.env.REACT_APP_BACKEND_URL || "").trim();
const redirectUriOverride = String(process.env.REACT_APP_REDIRECT_URI || "").trim();

/**
 * True when the API base URL targets a local machine (localhost / 127.0.0.1).
 *
 * @example
 * isLocalBackendUrl("http://localhost:8080");
 * // true
 */
const isLocalBackendUrl = (backendUrl) => {
  try {
    const { hostname } = new URL(String(backendUrl || "").trim());
    return hostname === "localhost" || hostname === "127.0.0.1";
  } catch (_) {
    return false;
  }
};

if (environment === "development") {
  config = dev;
} else if (environment === "staging") {
  config = staging;
} else {
  config = prod;
}

if (backendUrlOverride) {
  config = {
    ...config,
    BACKEND_URL: backendUrlOverride,
  };
  // Extension prod builds can override API to localhost; keep sign-in on local web app.
  if (isLocalBackendUrl(backendUrlOverride) && !redirectUriOverride) {
    config = {
      ...config,
      REDIRECT_URI: dev.REDIRECT_URI,
    };
  }
}

if (redirectUriOverride) {
  config = {
    ...config,
    REDIRECT_URI: redirectUriOverride,
  };
}

const sentimentAnalysisDefault = {
  granularity: "Sentence", // Sentence or Document level
  includeNeutral: true,
  customKeywords: "",
};

const editDestinationDefault = {
  project_id: "",
  bucket_name: "",
  dataset_name: "",
};

const intentAnalysisDefault = {
  goals: "", // Will be populated from API dropdown
  speakerType: "", // Will be populated from API dropdown
};

const discourseAnalysisDefault = {
  scope: "", // Will be populated from API dropdown
  metrics: [], // Will be populated from API dropdown (multiple selection)
};

// Integration type constants - adding as new constants
export const INTEGRATION_TYPES = {
  ZOOM: "zoom",
  CHORUS: "chorus",
  SALESLOFT: "salesloft",
  BIGQUERY: "bigquery",
  GCS: "gcs",
  GOOGLE_MEET: "google_meet",
  TEAMS: "teams",
  GMAIL: "gmail",
  GOOGLE_CALENDAR: "google_calendar",
  DATAGEN: "datagen",
};

/**
 * Enum for integration types
 * @readonly
 * @enum {string}
 */
export const IntegrationType = {
  GOOGLE_BIGQUERY: INTEGRATION_TYPES.BIGQUERY,
  GOOGLE_CLOUD_STORAGE: INTEGRATION_TYPES.GCS,
};

// Authentication status constants
export const AUTH_STATUS = {
  AUTHENTICATED: "authenticated",
  FAILED: "failed",
};

export const SOURCE_EXTRACT_SCOPE = {
  ORG: "ORG",
  TEAM: "TEAM",
  GROUP: "GROUP",
  INDIVIDUAL: "INDIVIDUAL",
};

export const CHROME_EXTENSION_URL =
  // TODO: update when the Task Mantis Chrome Web Store listing is published
  "https://chromewebstore.google.com/detail/starmesh-action-items/lgkghkpinglbfppipkblfncifndkcnoe";

// The landing page (docs/index.html, deployed to Firebase Hosting at
// taskmantis.com) owns the actual download links and OS detection, so both
// the web app and the landing page send people to the same place instead of
// each hardcoding its own copy of the installer URLs. #download sends Mac
// visitors to docs/download.html (thank-you + auto-start) and opens the
// install modal for everyone else (see the script at the bottom of
// docs/index.html).
export const DESKTOP_APP_LANDING_URL = "https://taskmantis.com/#download";

export default config;
export {
  topicModelingDefault,
  transformDefault,
  sentimentAnalysisDefault,
  editDestinationDefault,
  intentAnalysisDefault,
  discourseAnalysisDefault,
};
